import Vue from 'vue';
import VueBlurHash from 'vue-blurhash';
import IconButton from '@/components/icon-button.vue';
import IconMenu from '@/components/icon-menu.vue';

Vue.component('icon-button', IconButton);
Vue.component('icon-menu', IconMenu);
Vue.use(VueBlurHash);
